import _ from 'lodash';
import storeProvider from '../storeProvider';

export const getStore = () => (storeProvider.getStore());

export const getState = () => {
  const store = getStore();
  if (store) {
    return store.getState();
  }

  return false;
};

export const searchDuplicateTerms = (sourceTaxonomyId, targetTaxonomyId, taxonomies, termsIds) => {
  const { terms: sourceTaxonomyTerms = [] } = taxonomies.find(
    taxonomy => taxonomy.id.toString() === sourceTaxonomyId.toString(),
  ) || {};

  const filteredTerms = sourceTaxonomyTerms.filter(
    term => termsIds.includes(term.id),
  );

  const { terms: selectedTerms = [] } = taxonomies.find(
    taxonomy => taxonomy.id === targetTaxonomyId,
  ) || {};

  return selectedTerms.filter(
    selectedTerm => filteredTerms.some(
      filteredTerm => filteredTerm.name.toUpperCase() === selectedTerm.name.toUpperCase(),
    ),
  );
};

export const searchTerm = (termId) => (
  _.find(
    _.flatMap(getState().Metadata.taxonomies, 'terms'),
    { id: parseInt(termId) },
  )
);
